import { ChangeDetectorRef, Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { interval, Subscription } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';
import * as v from '../../../version';
import { ApplicationService } from '../../services/application.service';
import { UpdateNotificationDialogComponent } from '../update-notification-dialog/update-notification-dialog.component';
import { environment } from './../../../environments/environment';
import { MaterialModule } from '../../material.module';


@Component({
    selector: 'app-update-notification',
    templateUrl: './update-notification.component.html',
    imports: [MaterialModule]
})
export class UpdateNotificationComponent implements OnInit, OnDestroy {

  @Input()
  pollingInterval = 300000;

  private updateSub: Subscription;
  private shakeSub: Subscription;

  // Only show if in production
  public isProduction: boolean;

  withShake = false;

  showReload: boolean;

  private dialog = inject(MatDialog);
  private applicationService = inject(ApplicationService);
  private cdr = inject(ChangeDetectorRef);

  constructor() {
    this.isProduction = environment.production;
  }

  ngOnInit() {
    // if (!this.isProduction) return;

    this.updateSub =
      interval(this.pollingInterval)
        .pipe(
          startWith(0),
          switchMap(() => {
            return this.applicationService.getLatestVersion();
          })
        )
        .subscribe(res => this.checkVersion(res));
  }

  ngOnDestroy(): void {
    if (this.updateSub) {
      this.updateSub.unsubscribe();
      this.updateSub = null;
    }
  }

  reload(): void {
    this.dialog.open(UpdateNotificationDialogComponent, {});
  }

  private checkVersion(latest: string): void {

    this.showReload = this.normaliseVersion(latest) !== this.normaliseVersion(v.version.version);

    if (this.showReload) {
      this.startShaking();
    } else {
      this.stopShaking();
    }

    this.cdr.markForCheck();
  }

  private normaliseVersion(version: string | null | undefined): string {
    if (!version) {
      return '';
    }

    const parts = version
      .trim()
      .split('.')
      .map(part => part.trim())
      .filter(part => part.length > 0);

    while (parts.length > 0 && parts[parts.length - 1] === '0') {
      parts.pop();
    }

    return parts.join('.');
  }

  private startShaking() {
    if (!this.shakeSub) {
      this.shakeSub =
        interval(1500)
          .subscribe(() => {
            this.withShake = !this.withShake;
            this.cdr.markForCheck();
          });
    }
  }

  private stopShaking() {
    if (this.shakeSub) {
      this.shakeSub.remove(this.shakeSub);
      this.shakeSub.unsubscribe();
      this.shakeSub = null;
    }
  }

}
